import classNames from 'classnames';
import React, { useMemo } from 'react';

import Slides from 'common/components/RewindModal/Slides';
import trans from 'common/tools/translations/trans';

import styles from '../styles.module.scss';
import BottomActions from './component/BottomActions';

type FlashbackTypeProps = {
  data: {
    flashback_type: number;
  };
  onNext: () => void;
  isLastStep: boolean;
  trackingScreenName?: string;
};

const FlashbackType = ({ data, onNext, isLastStep }: FlashbackTypeProps) => {
  const { title, text } = useMemo(() => {
    const type = data?.flashback_type;

    if (type >= 1 && type <= 5) {
      return {
        title: trans('rewind.flashback.type.title'),
        text: trans('rewind.flashback.type.text')
      };
    }

    if (type === 6) {
      return {
        title: trans('rewind.flashback.type.6.title'),
        text: trans('rewind.flashback.type.6.text')
      };
    }

    return {
      title: trans('rewind.flashback.type.title'),
      text: trans('rewind.flashback.type.text')
    };
  }, [data]);

  return (
    <Slides>
      <div className={classNames(styles.contentLayout, styles.centeredLayout)}>
        <h1 className={styles.introTitle}>{title}</h1>
        <div className={styles.introText}>{text}</div>
      </div>
      <BottomActions
        showNext={!isLastStep}
        onNextClick={onNext}
        showShare={false}
      />
    </Slides>
  );
};

export default FlashbackType;
